import { combineReducers } from '@reduxjs/toolkit';

import { upcomingWidgetReducer as upcomingWidget } from './DashboardView/UpcomingWidget/slice';

export const dashboardReducer = combineReducers({ upcomingWidget });
